import Vue from 'vue';

Vue.config.productionTip = false;

import Radio from './components/Radio';
import Checkbox from './components/Checkbox';

import Testimonials from './components/Testimonials';
import Accordion from './components/Accordion';
import GoogleMap from './components/GoogleMap';


if(document.getElementById('app') && !document.getElementById('contact-form')) {
  var app = new Vue({
    el: '#app',
    components: { Testimonials, Accordion, GoogleMap }
  });
}

if(document.getElementById('contact-form')) {
  var contactForm = new Vue({
    el: '#contact-form',
    components: { Radio, Checkbox }
  });
}
